<script setup>
import Modal from "@js/components/Modal.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { title, content } = defineProps({
  title: {
    type: String,
    required: true,
  },
  content: {
    type: [String, Object],
    required: true,
  },
});

const isOpen = ref(false);

function setIsOpen(value) {
  isOpen.value = value;
}
</script>

<template>
  <slot name="button" :set-is-open="setIsOpen" />

  <Modal :is-open="isOpen" :set-is-open="setIsOpen" size="medium">
    <template #title>
      {{ title }}
    </template>

    <template #content>
      <div
        v-if="typeof content === 'string'"
        class="wysiwyg"
        v-html="content"
      ></div>

      <div v-else class="wysiwyg">
        <component :is="content" />
      </div>

      <slot name="complexContent" />
    </template>
  </Modal>
</template>
